module.exports = __webpack_public_path__ + "img/technology.54f533e9.svg";